import { observer } from 'mobx-react-lite'
import { Outlet, useParams } from 'react-router'
import { useEffect } from 'react'
import { FullPageWrapper } from 'shared/ui'
import {
  InboxLayerProvider,
  useInboxLayerContext,
} from 'pages/settings/pages/inboxes/context/inboxLayerContext'

const InboxProviderLayoutContent = observer(() => {
  const store = useInboxLayerContext()
  const { id } = useParams<{ id: string }>()

  useEffect(() => {
    if (id) {
      store.init(Number(id))
    }
  }, [id])

  return (
    <FullPageWrapper>
      <Outlet />
    </FullPageWrapper>
  )
})

export const InboxProviderLayout = () => {
  return (
    <InboxLayerProvider>
      <InboxProviderLayoutContent />
    </InboxLayerProvider>
  )
}
